import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import zhTW from '../locales/zh-TW';
import enUS from '../locales/en-US';

const dictionaries = {
  'zh-TW': zhTW,
  'en-US': enUS
};

const LocaleContext = createContext();

export const LocaleProvider = ({ children }) => {
  const [locale, setLocale] = useState(() => {
    const saved = localStorage.getItem('dm_locale');
    return saved && dictionaries[saved] ? saved : 'zh-TW';
  });

  useEffect(() => {
    localStorage.setItem('dm_locale', locale);
    // 更新 HTML lang 屬性以利 SEO
    document.documentElement.lang = locale;
  }, [locale]);

  const toggleLocale = () => {
    setLocale(prev => prev === 'zh-TW' ? 'en-US' : 'zh-TW');
  };

  /**
   * 翻譯函數
   * @param {string} key - 例如 'home.tabs.all'
   * @param {object} params - 替換變數 (目前用不到複雜替換，保留擴充性)
   */
  const t = useCallback((key, params = {}) => {
    const keys = key.split('.');
    let value = dictionaries[locale];
    
    for (const k of keys) {
      if (value && value[k] !== undefined) {
        value = value[k];
      } else {
        return key; // 找不到翻譯時回傳 key 本身作為提示
      }
    }
    
    // 如果有變數，進行簡單替換 (例如 "Hello {{name}}")
    if (typeof value === 'string' && Object.keys(params).length > 0) {
      let replaced = value;
      Object.keys(params).forEach(p => {
        replaced = replaced.replace(new RegExp(`{{${p}}}`, 'g'), params[p]);
      });
      return replaced;
    }
    
    return value;
  }, [locale]);

  return (
    <LocaleContext.Provider value={{ locale, toggleLocale, t }}>
      {children}
    </LocaleContext.Provider>
  );
};

export const useLocale = () => useContext(LocaleContext);